<template>
  <div id="app">
    <section>
      <button
          v-if="selectedInvoice.status === 'CONFIRMED'||selectedInvoice.status === 'MAILED'" class="btn-basic btn-red mb-3 mr-2"
          style="width: 180px;"
          @click="showModal()" :disabled="isChangingActiveState">
        Crediteer
      </button>
      <button
          type="button"
          style="width: 180px;"
          v-else-if="selectedInvoice.status === 'CREDIT_NOTED'" class="btn-basic btn-dark mb-3 mr2"
          @click="downloadCreditNote()">
        Download Creditnota PDF
      </button>
    </section>
    <modal id="inline-modal" v-cloak>
      <template slot="title">Creditnote datum</template>
      <div slot="body">
        <DateInputField class="w-50 d-inline-block" v-model="$store.state.administrationInvoice.selectedInvoiceCreditNoteDate" labelText="Te vermelden datum op creditnota"/>
      </div>
      <div slot="footer">
        <button class="btn-basic btn-outline-pulse-dark mr-2" @click="closeModal()">Annuleren</button>
        <button class="btn-basic btn-outline-pulse mr-2" @click="() => createCreditNoteWithDate()">Opslaan</button>
      </div>
    </modal>
  </div>
</template>
<script>
import { Modal, VoerroModal } from '@voerro/vue-modal';
import Vue from 'vue';
import {mapActions, mapGetters} from "vuex";
import DateInputField from "@/components/inputFields/DateInputField";
Vue.component('modal', Modal);
window.VoerroModal = VoerroModal;
VoerroModal.show('inline-modal');
export default {
  name: 'CreditNoteModal',
  components: {
    DateInputField,
  },
  computed: {
    ...mapGetters({
      selectedInvoice: "administrationInvoice/selectedInvoice",
      selectedCreditNoteDate: "administrationInvoice/selectedInvoiceCreditNoteDate"
    }),
  },
  methods: {
    ...mapActions("administrationInvoice", [
      "createCreditNote", "downloadSelectedCreditNotePDF"
    ]),
    showModal() {
      VoerroModal.show('inline-modal');
    },
    closeModal() {
      VoerroModal.hide('inline-modal');
    },
    downloadCreditNote() {
      this.isDownloadingCreditNote = true;
      this.downloadSelectedCreditNotePDF(this.selectedInvoice.id)
          .then(() => this.isDownloadingCreditNote = false)
          .catch(() => this.isDownloadingCreditNote = false);
    },
    createCreditNoteWithDate() {
      const promise = this.createCreditNote(this.selectedCreditNoteDate);

      promise.then(() => {
        VoerroModal.hide('inline-modal');
      });


    },
  },

};
</script>